/**
 * 接口调用日志上下文：为每个请求附加页面位置、账号等信息
 */

const SENSITIVE_KEYS = ['password', 'oldPassword', 'newPassword', 'confirmPassword', 'token', 'authorization']

function getCurrentAccount() {
  try {
    const userInfos = localStorage.getItem('userInfos') || sessionStorage.getItem('userInfos')
    if (userInfos) {
      const user = JSON.parse(userInfos)
      return user.userName || user.phonenumber || user.nickName || user.phone || ''
    }
  } catch (e) {
    // ignore
  }
  return ''
}

function getPageLocation() {
  if (typeof window === 'undefined') {
    return ''
  }
  return window.location.pathname + window.location.search
}

function getPageTitle() {
  if (typeof document === 'undefined') {
    return ''
  }
  return document.title || ''
}

function buildClientAction(config) {
  const method = (config.method || 'get').toUpperCase()
  const url = config.url || ''
  return `前端请求 ${method} ${url}`
}

/** HTTP 请求头仅支持 ISO-8859-1，中文等字符需 encodeURIComponent 编码 */
function safeHeaderValue(value) {
  if (value == null || value === '') {
    return ''
  }
  return encodeURIComponent(String(value))
}

export function attachApiLogHeaders(config) {
  config.headers = config.headers || {}
  config.headers['X-Page-Location'] = safeHeaderValue(getPageLocation())
  config.headers['X-Page-Title'] = safeHeaderValue(getPageTitle())
  const account = getCurrentAccount()
  if (account) {
    config.headers['X-Client-Account'] = safeHeaderValue(account)
  }
  config.headers['X-Client-Action'] = safeHeaderValue(buildClientAction(config))
  config.metadata = config.metadata || {}
  config.metadata.startTime = Date.now()
  return config
}

function maskValue(key, value) {
  if (SENSITIVE_KEYS.some(item => item.toLowerCase() === String(key).toLowerCase())) {
    return '******'
  }
  return value
}

function maskData(data) {
  if (!data || typeof data !== 'object') {
    return data
  }
  if (data instanceof FormData) {
    return '[FormData]'
  }
  if (Array.isArray(data)) {
    return data.map(item => maskData(item))
  }
  const result = {}
  Object.keys(data).forEach(key => {
    result[key] = maskValue(key, maskData(data[key]))
  })
  return result
}

export function logApiRequest(config) {
  const account = getCurrentAccount() || '匿名'
  console.info('[API请求]', {
    时间: new Date().toLocaleString(),
    页面: getPageLocation(),
    模块: getPageTitle(),
    账号: account,
    操作: buildClientAction(config),
    请求内容: maskData(config.params || config.data || {})
  })
}

export function logApiResponse(config, response, error) {
  const duration = config.metadata && config.metadata.startTime
    ? Date.now() - config.metadata.startTime
    : 0
  const account = getCurrentAccount() || '匿名'
  const payload = {
    时间: new Date().toLocaleString(),
    页面: getPageLocation(),
    模块: getPageTitle(),
    账号: account,
    操作: buildClientAction(config),
    耗时: `${duration}ms`,
    状态: error ? '失败' : '成功'
  }
  if (error) {
    payload.错误 = error.message || error
    console.error('[API响应]', payload)
    return
  }
  payload.响应内容 = maskData(response && response.data !== undefined ? response.data : response)
  console.info('[API响应]', payload)
}

export default {
  attachApiLogHeaders,
  logApiRequest,
  logApiResponse
}
